import { EntityApiService } from '@dfl/react-security';
import { IProductTemplate } from 'modules/inventory/settings/product-templates/interfaces';

class ProductTemplateService extends EntityApiService<IProductTemplate> {}

export default new ProductTemplateService('/ms-inventory/api/product-templates');
